/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type PeriodUsage = {
  /**
   * The number of servers enabled at the time of the request
   */
  actualEnabledServerCount: number;
  /**
   * The number of credits used. Only populated for platform admins.
   */
  credits?: number | undefined;
  /**
   * Whether the project has an active subscription
   */
  hasActiveSubscription: boolean;
  /**
   * The number of credits included in the tier. Only populated for platform admins.
   */
  includedCredits?: number | undefined;
  /**
   * The number of servers included in the tier
   */
  includedServers: number;
  /**
   * The number of tool calls included in the tier
   */
  includedToolCalls: number;
  /**
   * The number of servers used, according to the Polar meter
   */
  servers: number;
  /**
   * The number of tool calls used
   */
  toolCalls: number;
};

/** @internal */
export const PeriodUsage$inboundSchema: z.ZodMiniType<PeriodUsage, unknown> = z
  .pipe(
    z.object({
      actual_enabled_server_count: z.int(),
      credits: z.optional(z.int()),
      has_active_subscription: z.boolean(),
      included_credits: z.optional(z.int()),
      included_servers: z.int(),
      included_tool_calls: z.int(),
      servers: z.int(),
      tool_calls: z.int(),
    }),
    z.transform((v) => {
      return remap$(v, {
        "actual_enabled_server_count": "actualEnabledServerCount",
        "has_active_subscription": "hasActiveSubscription",
        "included_credits": "includedCredits",
        "included_servers": "includedServers",
        "included_tool_calls": "includedToolCalls",
        "tool_calls": "toolCalls",
      });
    }),
  );

export function periodUsageFromJSON(
  jsonString: string,
): SafeParseResult<PeriodUsage, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => PeriodUsage$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'PeriodUsage' from JSON`,
  );
}
